<fin-pax-details
  (ready)="openModalOrConfirm($event)"
  (unlockTravelingWith)="resetSeatMap()"
  [cartStatus$]="cartStatus$"
  [cartData$]="cartData$"
></fin-pax-details>

<fin-korea-notification
  *ngIf="showKoreaNotification$ | async"
  (confirmed)="confirmPaxDetails()"
  (close)="continueOrSkip = null"
  #koreaNotification
></fin-korea-notification>
